import { CommonDT, DateFilter, PageParams, ResultType, Sorter } from '../../CommonDT';
import { _delete, _get, _post, _put, _req } from '../../request';

export type InviteDataType = {
  uuid: string; // 主键 UUID
  userUuid: string; // 用户 UUID
  inviteUserUuid: string; // 被邀请人用户uuid
  inviteUsername: string; // 被邀请人用户名
  inviteDatetime: string; // 邀请日期时间 (ISO 格式字符串)
  awardPointCount: number; // 奖励积分数量
  awardTips: string; // 奖励提示
};

export type InviteBatchDataType = {
  bills: InviteDataType[];
};

export type InvitePageDataType = {
  pageParams: PageParams;
  filter?: InviteDataType;
  dateFilter?: DateFilter;
  sorter?: Sorter;
};

const get = async (id: string): Promise<ResultType> => {
  return await _get('/usr/invite/', id);
};

const list = async (data?: InviteDataType): Promise<ResultType> => {
  return await _post('/usr/invite/list', data);
};

const page = async (data?: InvitePageDataType): Promise<ResultType> => {
  return await _post('/usr/invite/page', data);
};

const batchSave = async (data: InviteBatchDataType): Promise<ResultType> => {
  return await _post('/usr/invite/batchSave', data);
};

const batchUpdate = async (data: InviteBatchDataType): Promise<ResultType> => {
  return await _put('/usr/invite/batchUpdate', data);
};

const alterStatus = async (inviteId: string, status: number): Promise<ResultType> => {
  return await _req('/usr/invite/alterStatus', 'PUT', { inviteId, status });
};

const batchRemove = async (ids: string[]): Promise<ResultType> => {
  return await _delete('/usr/invite/batchRemove', ids);
};

const userSign = async (userId: string): Promise<ResultType> => {
  return await _get('/usr/invite/userSign', userId);
};

const listByUserId = async (userId: string): Promise<ResultType> => {
  return await _req('/usr/invite/listByUserId', 'GET', { userId });
};

const InviteApi = {
  get,
  list,
  page,
  batchSave,
  batchUpdate,
  alterStatus,
  batchRemove,
  listByUserId,
};

export default InviteApi;
